import { render, staticRenderFns } from "./UserCheckout.vue?vue&type=template&id=006906f5&"
import script from "./UserCheckout.vue?vue&type=script&lang=js&"
export * from "./UserCheckout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports